import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { Row, Col, Space, Button } from "antd";
import { ShareAltOutlined, HeartOutlined } from "@ant-design/icons";

const Title = styled.h1`
  margin: 0;
  font-size: 22px;
  font-weight: 600;
  line-height: 1.3;
  letter-spacing: -0.2px;
`;

export default function Header({ title, city, country }) {
  return (
    <Row justify="space-between" align="middle">
      <Col>
        <Title>
          {title || "Listing"}
          {city ? ` in ${city}` : ""}
          {country ? `, ${country}` : ""}
        </Title>
      </Col>
      <Col>
        <Space size={12}>
          <Button
            type="text"
            icon={<ShareAltOutlined />}
            style={{ fontWeight: 600 }}
          >
            Share
          </Button>
          <Button
            type="text"
            icon={<HeartOutlined />}
            style={{ fontWeight: 600 }}
          >
            Save
          </Button>
        </Space>
      </Col>
    </Row>
  );
}

Header.propTypes = {
  title: PropTypes.string,
  city: PropTypes.string,
  country: PropTypes.string,
};
